exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")();
// imports
exports.push([module.id, "@import url(https://fonts.googleapis.com/css?family=Open+Sans:300,300i,400,400i,600,700);", ""]);
exports.push([module.id, "@import url(https://fonts.googleapis.com/css?family=Oswald:300,400,600,700);", ""]);

// module
exports.push([module.id, "body{-moz-osx-font-smoothing:grayscale;-webkit-font-smoothing:antialiased}.no-select{-webkit-user-select:none;-moz-user-select:none;-ms-user-select:none;user-select:none}.filtertags-container{display:flex;position:relative;align-items:center}.filtertags-container .relative-outer-popout-container{position:fixed}.filtertags-container .filtertags-remaining-container{display:flex;flex-direction:column;align-items:flex-start}.filtertags-container .filtertags-item{margin-left:4px;display:flex;align-items:center;background-color:#184e78;height:15px;border-radius:4px}.filtertags-container .filtertags-item-clear-text{font-family:Open Sans,sans-serif;font-size:8px;color:#184e78;cursor:pointer}.filtertags-container .filtertags-item-remaining{margin-top:4px;display:flex;align-items:center;background-color:#184e78;height:15px;border-radius:4px}.filtertags-container .filtertags-item-name{margin-left:5px;margin-right:5px;color:#fff;font-family:Open Sans,sans-serif;font-size:8px;white-space:nowrap}.filtertags-container .filtertags-item-remove{height:12px;width:12px;cursor:pointer}", ""]);

// exports
exports.locals = {
	"addGreen": "#4bb543",
	"inProgress": "#f5a623",
	"complete": "#5db348",
	"iconGrey": "#A4A4A4",
	"warmGreyTwo": "#9b9b9b",
	"gray": "#676767",
	"offBlack": "#2C2C2C",
	"lightElement": "#D8D8D8",
	"white": "#fff",
	"aoDarkBlue": "#184e78",
	"secondaryLabelFont": "#bababa",
	"nonExistant": "#9b9b9b",
	"red": "#D0011B"
};


//////////////////
// WEBPACK FOOTER
// ./~/css-loader!./~/sass-loader!./src/components/FilterTags/FilterTags.scss
// module id = 1563
// module chunks = 0